module.exports = __webpack_public_path__ + "static/img/prezzta.42f0b624.svg";